import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AiOutlineClose } from 'react-icons/ai';

import Spinner from '../../../components/Spinner';
import LocationInformation from './LocationInformation';

import CONSTANTS from '../../../utils/constants/CONSTANTS';
import { setAddLocation, setCurrentLocation, setEditLocation } from '../../../redux/location/LocationAction';

import './index.scss';

const AddLocation = ({ isEditDialog = false }) => {
  const dispatch = useDispatch();

  const addingLocation = useSelector((state) => state.locations?.addNewLocation);
  const currentLocation = useSelector((state) => state.locations?.currentLocation);
  const isEditLocation = useSelector((state) => state.locations?.isEditLocation);

  const [locationInfo, setLocationInfo] = useState({
    name: '',
    first_name: '',
    middle_name: '',
    last_name: '',
    admin_email: '',
    revenue_split: '',
  });

  useEffect(() => {
    if (isEditLocation && currentLocation) {
      const adminName = currentLocation.admin_name.split(' ');
      setLocationInfo({
        id: currentLocation.uuid,
        name: currentLocation.name,
        first_name: adminName[0],
        middle_name: adminName.length > 2 ? adminName[1] : ' ',
        last_name: adminName[adminName.length - 1],
        admin_email: currentLocation.admin_email,
        revenue_split: currentLocation.revenue_split || '',
      });
    }
  }, [isEditLocation, currentLocation]);

  const cancelAddLocation = () => {
    dispatch(setAddLocation(false));
    dispatch(setCurrentLocation(null));
    dispatch(setEditLocation(false));
  };

  return (
    <div className="add-location">
      <div className="box">
        <div className="top">
          <div className="back-arrow">
            <h3 className="heading">{isEditLocation ? 'Update Location' : 'Add Location'}</h3>
          </div>
          <AiOutlineClose style={CONSTANTS.ICON_STYLES} onClick={cancelAddLocation} />
        </div>
        {addingLocation ? (
          <div className="bottom">
            <LocationInformation
              locationInfo={locationInfo}
              setLocationInfo={setLocationInfo}
              isEditDialog={isEditDialog}
            />
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default AddLocation;
